import d from "./Modal.js";
import o, { useModal as e } from "@ebay/nice-modal-react";
var t = e,
  l = o.Provider,
  s = o.create;
o.hide;
export { l as ModalProvider, s as createModal, d as default, t as useModal };